// function that truncates a string to a certain length
export function truncateString(str: string, length: number) {
  return str.length > length ? `${str.substring(0, length)  }...` : str;
}
